// extracted by mini-css-extract-plugin
export default {"fontSize_1":"DaEVM6y8","fontSize_2":"Rhbo9rEK","fontSize_3":"OOqZ5SpN","fontSize_4":"T3Jai8bg","fontSize_5":"J4PMY8iZ","fontSize_6":"S7G2KxTX"};